import { useState, useEffect, useRef } from "react";

const useGroupMembers = (groupId, channelId = null) => {
    const [members, setMembers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const prevRequest = useRef(null); // Guarda a requisição anterior

    useEffect(() => {
        if (!groupId) {
            console.warn("HOOK: ID do grupo ou time não fornecido.");
            return;
        }

        console.log("HOOK: useEffect acionado com", { groupId, channelId });

        const controller = new AbortController();
        const signal = controller.signal;

        const fetchMembers = async () => {
            // Se a requisição for a mesma da anterior, evitamos rodá-la novamente
            const requestKey = `${groupId}-${channelId || "no-channel"}`;
            if (prevRequest.current === requestKey) return;
            prevRequest.current = requestKey; // Atualiza o identificador da requisição atual

            try {
                console.log(
                    channelId
                        ? `HOOK: Buscando membros do canal ID: ${channelId} no time ID: ${groupId}`
                        : `HOOK: Buscando membros do grupo/time ID: ${groupId}`
                );

                setLoading(true);
                setError(null);

                const endpoint = channelId
                    ? `${process.env.REACT_APP_API_URL}/api/team/${groupId}/channel/${channelId}/members`
                    : `${process.env.REACT_APP_API_URL}/api/group-members/${groupId}`;

                const response = await fetch(endpoint, { signal });

                if (!response.ok) {
                    throw new Error(`Erro ao obter membros: ${response.statusText}`);
                }

                const data = await response.json();
                if (data.status === "success") {
                    console.log("HOOK: Membros obtidos com sucesso:", data.members);
                    setMembers(data.members);
                } else {
                    throw new Error(data.message || "Erro desconhecido");
                }
            } catch (err) {
                if (err.name === "AbortError") {
                    console.log("HOOK: Requisição abortada.");
                } else {
                    console.error("HOOK: Erro ao buscar membros:", err.message);
                    setError(err.message);
                }
            } finally {
                setLoading(false);
            }
        };

        fetchMembers();

        return () => {
            controller.abort();
        };
    }, [groupId, channelId]);

    return { members, loading, error };
};

export default useGroupMembers;
